import React, { useMemo } from 'react';
import './style.scss';
import { NFTRank } from 'shared';
import clsx from 'clsx';
import NftRankLine from '../../../../../general/nft/rankLine';

type Rank = {
  rank: NFTRank;
  isUpgrade: boolean;
};

interface Props {
  newLevel: number;
  levelChange: number;
  oldRank: NFTRank;
  newRank: NFTRank;
  className?: string;
}

const FightResultsLevelBlock = (props: Props) => {
  const { newLevel, levelChange, className, oldRank, newRank } = props;

  const displayRank = useMemo<Rank | false>(() => {
    // if downgrade within same rank, but with changed stars amount
    if (
      levelChange < 0 &&
      newRank.name === oldRank.name &&
      newRank.stars !== oldRank.stars
    ) {
      return { rank: newRank, isUpgrade: false };
    }

    // if upgrade, and diff in stars amount or different rank name
    if (
      levelChange > 0 &&
      (newRank.name !== oldRank.name || newRank.stars !== oldRank.stars)
    ) {
      return { rank: newRank, isUpgrade: true };
    }

    return false;
  }, [oldRank, newRank, levelChange]);

  const uiChange = useMemo<string>(() => {
    if (levelChange === 0) return '';
    if (levelChange > 0) return ` (+${levelChange})`;
    return ` (${levelChange})`;
  }, [levelChange]);

  //draw
  if (levelChange === 0) return null;

  return (
    <div className={clsx('fight-results-level', className)}>
      <div className='frl-block'>
        <p>New Level:</p>
        <span className='frl-block-value'>
          {newLevel} {uiChange}
        </span>
      </div>
      {displayRank && (
        <div className='frl-block'>
          <p>Rank {displayRank.isUpgrade ? 'Upgrade' : 'Downgrade'}</p>
          <NftRankLine rank={displayRank.rank} className='frl-block-value' />
        </div>
      )}
    </div>
  );
};

export default FightResultsLevelBlock;
